namespace $ {

	type $shm_hitalama_profile_migration_step = {
		version: number
		migrate: ( profile: $shm_hitalama_profile )=> void
	}
	type $shm_hitalama_profile_map_list = $giper_baza_list_link

	export class $shm_hitalama_profile_migration {

		static migrations(): readonly $shm_hitalama_profile_migration_step[] {
			return [
				{
					version: 1,
					migrate: profile => {
						this.migrate_maps_link( profile )
					},
				},
				{
					version: 2,
					migrate: profile => {
						this.migrate_agent_settings( profile )
					},
				},
			]
		}

		static latest_version() {
			return this.migrations().at( -1 )?.version ?? 0
		}

		@ $mol_action
		static migrate( profile: $shm_hitalama_profile ) {
			const migrations = this.migrations()
			const target_index = migrations.length - 1
			if( target_index < 0 ) return profile.version()

			const version = profile.version()
			let version_index = version ? migrations.findIndex( migration => migration.version === version ) : -1
			if( version_index < 0 && version ) throw new Error( `Unknown hitalama profile version "${ version }"` )
			if( version_index >= target_index ) return version

			for( let next_index = version_index + 1; next_index <= target_index; ++next_index ) {
				const migration = migrations[ next_index ]
				if( !migration ) throw new Error( `Missing hitalama profile migration to version index "${ next_index }"` )

				migration.migrate( profile )
				const next_version = profile.version( migration.version )
				if( next_version !== migration.version ) {
					throw new Error( `Hitalama profile migration expected version "${ migration.version }", got "${ next_version }"` )
				}
			}

			return profile.version()
		}

		@ $mol_action
		static migrate_maps_link( profile: $shm_hitalama_profile ) {
			this.migrate_list_link(
				profile,
				profile.Maps()?.cast( $giper_baza_list_link.to( ()=> $shm_hitalama_map ) ),
				list => profile.Maps(null)?.remote( list ),
			)
			this.migrate_list_link(
				profile,
				profile.Maps_removed()?.cast( $giper_baza_list_link.to( ()=> $shm_hitalama_map ) ),
				list => profile.Maps_removed(null)?.remote( list ),
			)
		}

		static migrate_list_link(
			profile: $shm_hitalama_profile,
			old_list: $shm_hitalama_profile_map_list | null | undefined,
			next: ( list: any )=> void,
		) {
			const links = old_list?.units()
				.filter( ( unit: any ) => unit.tag() !== 'solo' )
				.map( ( unit: any ) => old_list.land().sand_decode( unit ) )
				.filter( ( link: any ): link is $giper_baza_link => link instanceof $giper_baza_link )
			if( !links?.length ) return

			const area = profile.land().area_make()
			const list = $giper_baza_glob.Pawn( area.link(), $giper_baza_list_link.to( ()=> $shm_hitalama_map ) )
			list.items( links )
			next( list )
		}

		@ $mol_action
		static migrate_agent_settings( profile: $shm_hitalama_profile ) {
			type Agent_settings = {
				url?: string
				token?: string
			}

			const prev = ( profile.store( 'agent_settings' ) ?? {} ) as Agent_settings
			const next = { ... prev }

			const local_url = String( $mol_state_local.value< string >( 'hitalama_agent_url' ) ?? '' ).trim()
			if( local_url && !String( next.url ?? '' ).trim() ) next.url = local_url

			const local_token = String( $mol_state_local.value< string >( 'hitalama_agent_token' ) ?? '' ).trim()
			if( local_token && !String( next.token ?? '' ).trim() ) next.token = local_token

			if( next.url === prev.url && next.token === prev.token ) return

			profile.store( 'agent_settings', next )
		}

	}

}
